module.exports = __webpack_public_path__ + "static/media/FORMULARIO_DIETOTERAPIA.b4d297cf.pdf";